import {Component, Input, Output, EventEmitter} from '@angular/core';

import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ModalLogout } from '../../../modals/components/modalLogout/modalLogout.component';

@Component({
  selector: 'ba-menu-item',
  templateUrl: './baMenuItem.html',
  styleUrls: ['./baMenuItem.scss']
})
export class BaMenuItem {

  @Input() menuItem:any;
  @Input() child:boolean = false;

  @Output() itemHover = new EventEmitter<any>();
  @Output() toggleSubMenu = new EventEmitter<any>();

  constructor(private _modalService: NgbModal){
    
  }

  public onHoverItem($event):void {
   
    this.itemHover.emit($event);
  }

  public onToggleSubMenu($event, item):boolean {
    $event.item = item;
    this.toggleSubMenu.emit($event);
    return false;
  }

  public childSelected():boolean{
    if(!this.child && this.menuItem.children!=null){
      for(var child of this.menuItem.children){
        if(child.selected)
          return true;
      }
    }
    return false;
  }

  public showModal(): void {
    const activeModal = this._modalService.open(ModalLogout, {size: 'sm'});
  }

}



// WEBPACK FOOTER //
// /app/src/app/theme/components/baMenu/components/baMenuItem/baMenuItem.component.ts